import(/* webpackMode: "eager" */ "/vercel/path0/apps/client/app/markets/page.tsx");
